import {useDebugValue} from 'react';

import {useSettings} from './';

const defaultSettings = {
    isOpen: false,
    readOnly: false,
    showContinueButton: true
};

function useDatesSettings(props) {
    const {
        datesSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useDatesSettings};
